import React, { useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DataGrid } from '@mui/x-data-grid';
import SemesterTools from './SemesterTools';
import SemesterModel from './SemesterModel';
import { SemesterDelete, SemesterShowdata } from '../../../services/LoginPageService';
import { Tooltip } from '@mui/material';
import DeleteConfirmationDailog from '../../../utils/confirmDeletion';
import NotificationBar from '../../notification/ServiceNotificationBar';

const SemesterList = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editSemester, setEditSemester] = useState('');
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  const columns = [
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'specialization',
      headerName: 'Specialization',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'semester',
      headerName: 'Year',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'description',
      headerName: 'Description',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'sms_disabled',
      headerName: 'SMS Status',
      headerClassName: 'super-app-theme--header',
      minWidth: 120, flex: 1, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <span style={{ color: params.value ? '#d32f2f' : '#2e7d32', fontWeight: 500 }}>
          {params.value ? 'Disabled' : 'Enabled'}
        </span>
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 250,
      cellClassName: 'actions',
      disableClickEventBubbling: true,
      getActions: (params) => [
        <EditData selectedRow={params.row} />, 
        <DeleteData selectedRow={params.row} />,
        
      ],
    },
  ];

  useEffect(()=>{
    SemesterShowdata(handleSemesterShow,handeSemesterException);
  },[refreshData]);

  const handleSemesterShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }
  
  const handeSemesterException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  function EditData(props) {
    return (
      <Tooltip title="Edit">
        <EditIcon style={{cursor: 'pointer'}}
          onClick={(event) => {
            event.stopPropagation();
            setIsAddButton(false);
            setEditSemester(props.selectedRow);
            setOpen(true);
          }}
        />
      </Tooltip>
    );
  }

  function DeleteData(props) {
    return (
      <Tooltip title="Delete">
        <DeleteIcon style={{cursor: 'pointer'}}
            onClick={() => {
            setDeleteId(props.selectedRow.id);
            console.log(props.selectedRow.id);
            setDeleteDailogOpen(true); 
          }}
        />
      </Tooltip>
    );
  }

  const DeleteFunction =()=>{
    SemesterDelete(handleDeleteSuccess,handleDeleteException);
  }

  const handleDeleteSuccess = (dataObject) =>{
    console.log(dataObject);
      setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    }); 
    setTimeout(()=>{
        setDeleteDailogOpen(false);
      }, 2000);  
    setRefreshData(oldValue => !oldValue);
  }

  const handleDeleteException = (errorObject, message) =>{
    console.log(message);
    setNotification({
      status: true,
      type: 'error',
      message:message,
    });
  }
    
  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };
  
  return (
    <div style={{ height: 520, width: '98%',overflow: "scroll" }}>
      <SemesterTools
          setIsAddButton={setIsAddButton}
          editSemester={editSemester}
          setOpen={setOpen}
          setEditSemester={setEditSemester}   
      />

      <SemesterModel
        isAddButton={isAddButton}
        editSemester={editSemester}
        setEditSemester={setEditSemester} 
        open={open}
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        handleClose={handleClose}
        openNotification={openNotification}
        setNotification={setNotification}
      />

      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
        deleteService={SemesterDelete}
        handleSuccess={handleDeleteSuccess}
        handleException={handleDeleteException}
      />

      <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
        height: '480px',
        width: '100%',
        '& .super-app-theme--header': {
          WebkitTextStrokeWidth:'0.6px',
        },
        }}
      />
    </div>
  )
}

export default SemesterList
